<div class="space-y-6" data-testid="subcriteria-content">
  <h1 class="text-xl font-bold mb-6" data-testid="subcriteria-title">
    {{ 'subcriteria.attribute.title.first' | transloco }}
  </h1>
  <h3 class="text-lg font-bold mb-6" data-testid="subcriteria-title">
    {{ 'subcriteria.attribute.title.second' | transloco }}
  </h3>
  <div class="criteria-evaluation-attributes" data-testid="criteria-evaluation-attributes">
    @if (hasAttributes()) {
      <app-badge-list
        [items]="subCriteriaPanel().badges"
        [headerInputTemplate]="headerInputTemplate"
        [isOpenable]="false"
        data-testid="subcriteria-grid"
      >
        <ng-template #headerInputTemplate let-item>
          <app-importance-score-selector
            [selectedValue]="item.originalItem.score"
            (valueChange)="onScoreSelected(item.originalItem.directusId, $event)"
            [disabled]="isScoreSelectionDisabled()"
            [testId]="'selected-attribute-label-' + item.originalItem.directusId"
          ></app-importance-score-selector>
          @if (showConsistency()) {
            <app-attribute-consistency-status
              [consistency]="item.originalItem.consistency"
              [testId]="item.originalItem.directusId"
              (detailsRequested)="onConsistencyDetailsRequested(item.originalItem)"
            />
          }
        </ng-template>
      </app-badge-list>

      @if (canSave()) {
        <div class="flex justify-end gap-2 mt-6">
          <app-project-step-save-button
            [loading]="isSaving()"
            [disabled]="isSaving()"
            (clicked)="onSave()"
          ></app-project-step-save-button>
        </div>
      }
    } @else {
      <div class="text-center py-8" data-testid="no-attributes-message">
        <i class="pi pi-info-circle text-4xl text-gray-400 mb-4"></i>
        <h3 class="text-lg font-semibold text-gray-600 mb-2">
          {{ 'shared.subcriteriaAttributes.noSubcriteriaTitle' | transloco }}
        </h3>
        <p class="text-gray-500 max-w-md mx-auto">
          {{ 'shared.subcriteriaAttributes.noSubcriteriaMessage' | transloco }}
        </p>
      </div>
    }
  </div>
</div>

<app-audit-info [auditInfo]="lastSaveAuditInfo()" />

@if (showConsistency()) {
  @if (openedAttribute(); as attribute) {
    <app-attribute-consistency-dialog
      [visible]="isConsistencyDialogVisible()"
      [projectId]="projectId()"
      [scaNumber]="attribute.scaNumber"
      [attributeTranslations]="attribute.translations"
      [consistency]="attribute.consistency"
      [saving]="savingConsistency()"
      (visibleChange)="onConsistencyDialogVisibleChange($event)"
      (resolved)="onConsistencyResolved($event)"
    />
  }
}
